import React, { useState, useEffect } from "react";
// import useCountdown from "../../../hooks/useCountDown";
import Web3 from "web3";
import abi from "constants/abi";
import contracts from "constants/contracts";
import { useBalance, useAccount } from "wagmi";
import { amountFormatter } from "utils/formatBalance";
import { ethers } from "ethers";
import { getTheRoundTimeRemaining } from "../../../utils/functions";
import useCountdown from "../../../hooks/useCountDown";
import getNodeUrl from "../../../utils/getRpcUrl";

//var rpc = getNodeUrl();
//console.log(rpc);
//const web3 = new Web3(new Web3.providers.HttpProvider(rpc));
//const provider = new ethers.providers.Web3Provider(rpc);
//const signer = provider.getSigner();

//const contract = new web3.eth.Contract(abi.AUCTION, contracts.AUCTION);

const Banner = ({ mybid, dataToBanner, handleChildClick }) => {
  const { address } = useAccount();
  //console.log(dataToBanner);
  // const [formattedTimeLeft, setFormattedTimeLeft] = useState("0:00:00");

  const [highestBid, sethighestBid] = useState(0);
  const [lowestBid, setlowestBid] = useState(0);
  const [myRank, setmyRank] = useState(0);
  const [totalParticipants, settotalParticipants] = useState(0);
  const [NFTSLeft, setNFTSLeft] = useState(0);
  const [Bid, setBid] = useState(0);
  const [days, setdays] = useState(0);
  const [minutes, setminutes] = useState(0);
  const [hours, sethours] = useState(0);
  const [seconds, setseconds] = useState(0);

  const [formattedTimeLeft, setFormattedTimeLeft] = useState("");

  const syncTimerRef = React.useRef(0);
  // local timer that runs every second and decrements local value

  const timeleft = useCountdown("auction");

  useEffect(() => {
    setlowestBid(
      dataToBanner && dataToBanner[0]
        ? parseInt(dataToBanner[0][0]._hex) / 10 ** 18
        : 0
    );

    sethighestBid(
      dataToBanner && dataToBanner[1]
        ? parseInt(dataToBanner[1][0]._hex) / 10 ** 18
        : 0
    );
    setmyRank(
      dataToBanner && dataToBanner[0]
        ? parseInt(dataToBanner[2][0]._hex) 
        : 0
    );
    sethighestBid(
      dataToBanner && dataToBanner[1]
        ? parseInt(dataToBanner[1][0]._hex) / 10 ** 18
        : 0
    );
    setFormattedTimeLeft(timeleft[0]);
    setdays(timeleft[1]);
    sethours(timeleft[2]);
    setminutes(timeleft[3]);
    setseconds(timeleft[4]);
  }, [timeleft]);

  const setBidInput = (e) => {
    setBid(e);
  };

  return (
    <div className="pt-0 lg:pt-[67px]">
      <div className="container">
        <div className="max-w-[1104px] mx-auto">
          <div className="flex lg:flex-row flex-col gap-[80px] lg:gap-[130px]">
            <div className="grow mt-[50px] xl:mt-[88px] ">
              <h2 className="text-[20px] md:text-[28px] leading-[33px] font-semibold mb-[2px]">
                The <span className="text-bright-green">R34P</span> DAO{" "}
              </h2>
              <h1 className="text-res-lg mb-[24px] font-black ">
                <span className="text-bright-green ">Tiered Access</span> NFT
                Auction
              </h1>

              <p className="text-res-ls font-semibold mb-[29px]">
                The R34P DAO is excited to announce our upcoming NFT presale!
                This is your chance to own a piece of the DAO and join our
                community of DeFi enthusiasts. Our NFTs are unique and
                exclusive, and owning one will give you special access to our
                platform and governance decisions.
              </p>
              <a href="/nftone" className="text-large font-bold" style={{fontSize:"larger", cursor:"pointer", textDecoration:"underline"}}>Interested in larger allocations and joining the DAO group?</a>
            </div>

            {/* cards wrap */}

            <div className="w-full lg:w-[471px] bg-custom-gradient rounded-[10px] flex-none pt-[49px] pb-[66px] px-[20px] md:pl-[63px] md:pr-[62px]">
              <h2 className="text-center text-main-black text-res-base font-extrabold mb-[25px]">
                Auction Ends in {formattedTimeLeft}
              </h2>
              <div className="flex justify-center">
                <div className="flex gap-[10px] md:gap-[14px]">
                  <div className="w-[60px] md:w-[69px] px-[2px] md:px-[11px] pt-[17px] pb-[20px] bg-light-black rounded-[10px] h-[89px] text-center">
                    <h2 className="font-extrabold text-[20px] md:text-[28px] leading-[34px] mb-[6px]">
                      {days}
                    </h2>
                    <p className="font-extrabold text-[10px] leading-3">DAYS</p>
                  </div>
                  <div className="w-[60px] md:w-[69px] px-[2px] md:px-[11px] pt-[17px] pb-[20px] bg-light-black rounded-[10px] h-[89px] text-center">
                    <h2 className="font-extrabold text-[20px] md:text-[28px] leading-[34px] mb-[6px]">
                      {hours}
                    </h2>
                    <p className="font-extrabold text-[10px] leading-3">
                      HOURS
                    </p>
                  </div>
                  <div className="w-[60px] md:w-[69px] px-[2px] md:px-[11px] pt-[17px] pb-[20px] bg-light-black rounded-[10px] h-[89px] text-center">
                    <h2 className="font-extrabold text-[20px] md:text-[28px] leading-[34px] mb-[6px]">
                      {minutes}
                    </h2>
                    <p className="font-extrabold text-[10px] leading-3">
                      MINUTES
                    </p>
                  </div>
                  <div className="w-[60px] md:w-[69px] px-[2px] md:px-[11px] pt-[17px] pb-[20px] bg-light-black rounded-[10px] h-[89px] text-center">
                    <h2 className="font-extrabold text-[20px] md:text-[28px] leading-[34px] mb-[6px]">
                      {seconds}
                    </h2>
                    <p className="font-extrabold text-[10px] leading-3">
                      SECONDS
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-[31px] flex   justify-center text-res-xs font-medium text-main-black">
                <div>
                  <p>
                    Available NFTs:{" "}
                    <span className="font-extrabold ">1000</span>
                  </p>
                  <p className="my-[11px]">
                    Current Highest Bid:{" "}
                    <span className="font-extrabold ">{highestBid} ETH</span>
                  </p>
                  <p className="my-[11px]">
                    1000th Highest Bid:{" "}
                    <span className="font-extrabold ">{lowestBid} USDT</span>
                  </p>
                  <p className="my-[11px]">
                    Your Bid:{" "}
                    <span className="font-extrabold ">
                      {mybid > 0 ? mybid : 0} ETH
                    </span>
                  </p>
                  <p className="my-[11px]">
                    Your Rank:{" "}
                    <span className="font-extrabold ">
                    #{myRank > 0 && myRank!=10000 ? myRank : 'unranked'}
                    </span>
                  </p>
                </div>
              </div>

              <div className="mt-[31px]">
                <form>
                  <input
                    type="number"
                    className="h-[40px] rounded-[5px] w-full bg-light-black px-[22px] pt-[19px] pb-[18px] text-white placeholder:text-[#747474] text-res-xs font-medium"
                    placeholder="Enter ETH Amount to Bid"
                    //value={amountFormatter(Input, 7)}
                    // value={color}
                    onChange={(e) => setBidInput(e.target.value)}
                  />
                </form>
                <button
                  onClick={(event) => handleChildClick(Bid)}
                  className="w-full rounded-[5px] bg-white h-[40px] mt-[32px] text-light-black font-bold text-res-normal"
                >
                  <span>BID NOW</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
